import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_foreign_exchange_summary,
    getReportLabel: () => t`Exchange Gain/Loss Summary`,
    getColumns: () => [],
};
